import { databases } from "@/lib/appwrite";
import { sendTravelUpdateToN8n } from "@/requests/travels/webhook/sendTravelUpdateToN8n";
import { fetchUsersWithProfiles } from "@/lib/manager realtime/userCache";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const TRAVELS_COLLECTION_ID = import.meta.env.VITE_TRAVELS_REQUESTS_COLLECTION_ID;

export type UpdateTravelRequestData = {
    userId: string;  // ← AGREGADO
    title: string;
    tripPurpose: string;
    startDate: string;
    endDate: string;
    status: "pending" | "approved" | "rejected";
    address?: string;
    isInternational: boolean;
    transportationType?: string;
    estimatedCost?: number[];
    companies: string[];
    clients: string[];
    isGroup: boolean;
    usersId: string[];
    provinces: string[];
    countries: string[];
};

export async function updateTravelRequest(
    travelId: string,
    travelData: UpdateTravelRequestData,
    userName: string,        
    userEmail: string,       
    previousStatus: string  
) {
    try {
  
        const updatedTravel = await databases.updateDocument(
            DATABASE_ID,
            TRAVELS_COLLECTION_ID,
            travelId,
            {
                title: travelData.title,
                tripPurpose: travelData.tripPurpose,
                startDate: travelData.startDate,
                endDate: travelData.endDate,
                status: travelData.status,
                address: travelData.address || null,
                isInternational: travelData.isInternational,
                transportationType: travelData.transportationType || null,
                estimatedCost: travelData.estimatedCost || [],
                companies: travelData.companies,
                clients: travelData.clients,
                isGroup: travelData.isGroup,
                usersId: travelData.usersId,
                provinces: travelData.isInternational ? [] : travelData.provinces,
                countries: travelData.isInternational ? travelData.countries : [],
            }
        );

        // Enviar webhook SOLO si estaba rejected
        if (previousStatus === 'rejected') {
            try {

                const usersWithProfiles = await fetchUsersWithProfiles();


                const currentUser = usersWithProfiles.find(u => u.id === travelData.userId);

                if (currentUser?.profile?.idSupervisor) {

                    const supervisor = usersWithProfiles.find(
                        u => u.id === currentUser.profile?.idSupervisor
                    );

                    if (supervisor?.email) {

                        await sendTravelUpdateToN8n(
                            travelId,
                            travelData.title,
                            userName,
                            userEmail,
                            supervisor.email
                        );
                    } else {
                        console.warn(' No se encontró email del supervisor en cache');
                    }
                } else {
                    console.warn(' Usuario no tiene supervisor asignado');
                }
            } catch (webhookError) {
                console.warn(' Error enviando webhook (actualización guardada):', webhookError);
                // No lanzamos error para que no afecte el flujo principal
            }
        } else {
            console.log('ℹ No se envía notificación (estado no era rejected)');
        }

        return {
            success: true,
            data: updatedTravel,
        };
    } catch (error) {
        console.error("Error updating travel request:", error);
        throw error;
    }
}